import React, { Component } from "react";
import BasicCommonFileSettings from "./BasicCommonFileSettings";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";

export class BasicDropboxSettings extends Component {
  state = {
    authOnDomain: false,
    dropboxUserIndexAs: "",
    childSettings: [],
  };

  componentDidMount() {
    this.settingsUpdated();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.settingsUpdated();
    }
  }

  render() {
    return (
      <div>
        {/* <BasicCommonFileSettings setSettings={this.setChildSettings} /> */}
        {/* <FormControlLabel
          style={{ marginTop: 10 }}
          control={
            <Checkbox checked={this.state.authOnDomain} onChange={(e) => this.setState({ authOnDomain: e.target.checked })} value="authOnDomain" />
        }
        label="Access Dropbox via the Business API"
        />
        <Collapse in={this.state.authOnDomain}>
          <TextField
            fullWidth label="Dropbox user to index as" onChange={(e) => this.setState({ dropboxUserIndexAs: e.target.value })} value={this.state.dropboxUserIndexAs} style={{width: "50%"}}></TextField></Collapse> */}
      </div>
    );
  }

  settingsUpdated = () => {
    this.props.setSpiderProperties({
      dropboxUser: this.state.dropboxUserIndexAs,
      authOnDomain: this.state.authOnDomain,
    });
  };
}

export default BasicDropboxSettings;
